import React, { useCallback, useMemo } from 'react';
import { connect } from "react-redux";
import { s3FeatureImagePath, THUMBNAIL_SIZES } from "../../../../../../../../misc/utils";
import {
  findGLBLink,
  getDepthFromDbFeature,
  getHeightFromDbFeature,
  getRelatedFeatureMetadata, getThirdPartyAR3DMetaData,
  getWidthFromDbFeature
} from "../../../../../../helpers/sqft3dArHelper";
import LookFeaturePrice from "../../../../../../../look/lookNavigation/lookMain/lookListFeature/lookFeaturePrice";
import FeatureName from "../../../../../../../visComponents/featureName";
import {mobileDragHelper} from "../../../../../canvas/helpers/mobileDragHelper";
import {useMobileDrag} from "../../../../../../hocs/useMobileDrag";
import {createCustomDragImage} from "../../../../../canvas/helpers/desktopDragHelper";
import sqftConfig from "../../../../../canvas/store/sqftConfig";

const SqftOptionsRelatedItemRow = (props) => {
  const { feature, index, style, partId, parentFeature, activeItemIndex, setActiveItemIndex, itemClickCallback } = props;
  const { lookViewType, isMobile } = props;

  const className = useMemo(() => {
    const isActive = activeItemIndex === feature;
    let classNames = " lm-feature lm-feature--type-" + lookViewType + (isActive ? " lm-feature--active" : "")
    return classNames
  }, [lookViewType, activeItemIndex, feature]);

  const imageUrl = useMemo(() => feature.dbFeature.thumbnailUrl
    ? s3FeatureImagePath(feature.dbFeature, THUMBNAIL_SIZES.medium)
    : feature.dbFeature.customThumbnail, [feature.dbFeature]);

  const { width, height, depth } = useMemo(() => {
    const thirdPartyAR3DMetaData = getRelatedFeatureMetadata(feature, parentFeature);
    return {
      width: getWidthFromDbFeature(feature.dbFeature, thirdPartyAR3DMetaData),
      height: getHeightFromDbFeature(feature.dbFeature, thirdPartyAR3DMetaData),
      depth: getDepthFromDbFeature(feature.dbFeature, thirdPartyAR3DMetaData)
    };
  }, [feature, parentFeature]);

  // Prepare drag data
  const dragData = useMemo(() =>
    mobileDragHelper.createFeatureDragData(feature, parentFeature, partId, {
      width, height, depth
    }), [feature, parentFeature, partId, width, height, depth]
  );

  // Handle drop callback
  const handleDrop = useCallback((dropInfo) => {
    console.log('handleDrop called:', dropInfo);
    mobileDragHelper.handleCanvasDrop(dropInfo);
  }, []);

  // Handle tap callback
  const handleTap = useCallback(() => {
    setActiveItemIndex(feature);
    itemClickCallback(feature, parentFeature);
  }, [feature, parentFeature, setActiveItemIndex, itemClickCallback]);

  // Use mobile drag hook
  const { isDragging, elementRef, handlers, dragStyle } = useMobileDrag({
    onDrop: handleDrop,
    onTap: handleTap,
    dragData: dragData,
    dragImageUrl: imageUrl,
    dragText: feature.getFeatureName(),
    enabled: isMobile
  });

  void isDragging;

  // Desktop click handler
  const handleButtonClick = useCallback((e) => {
    if (!isMobile) {
      e.preventDefault();
      setActiveItemIndex(feature);
      itemClickCallback(feature, parentFeature);
    }
  }, [feature, parentFeature, setActiveItemIndex, itemClickCallback, isMobile]);

  // Desktop drag handlers
  const setDataTransfer = (dataTransfer) => {
    dataTransfer.setData('featureId', feature.dbFeature.id);
    dataTransfer.setData('parentFeatureId', parentFeature.dbFeature.id);
    dataTransfer.setData('width', width);
    dataTransfer.setData('height', height);
    dataTransfer.setData('depth', depth);
    dataTransfer.setData('partId', partId);

    const dragImage = new Image();
    dragImage.src = imageUrl;
    dataTransfer.setDragImage(dragImage, 0, 0);
  };

  const handleDragStart = (e) => {
    setDataTransfer(e.dataTransfer);

    const dbFeature = feature.dbFeature;
    const thirdPartyAR3DUrl = findGLBLink(dbFeature.thirdPartyAR3DUrls);
    const thirdPartyAR3DMetaData = getThirdPartyAR3DMetaData(dbFeature, thirdPartyAR3DUrl);
    const width = getWidthFromDbFeature(dbFeature, thirdPartyAR3DMetaData);
    const depth = getDepthFromDbFeature(dbFeature, thirdPartyAR3DMetaData);
    const title = 'W:' + width + ' D:' + depth;

    const preview = createCustomDragImage(imageUrl, title, width * sqftConfig.scale, depth * sqftConfig.scale);

    // Set drag image with offset (0, 0) to position at cursor
    e.dataTransfer.setDragImage(preview.element, 0, 0);
  };

  return (
    <div
      ref={elementRef}
      className={className}
      style={{
        ...style,
        ...(isMobile ? dragStyle : {})
      }}
      key={index}
      draggable={!isMobile}
      onDragStart={!isMobile ? handleDragStart : undefined}
      {...(isMobile ? handlers : {})}
      onClick={handleButtonClick}
    >
      <div className={"lm-feature__thumbnail lm-feature__thumbnail--full "}>
        {imageUrl ? <img src={imageUrl} className="feature-thumbnail__image" alt="" /> : null}
      </div>
      <div className={"lm-feature__content"}>
        <div className="lm-feature__content-name">
          {feature.getFeatureName()}
        </div>
        <div className="lm-feature__content-description">
          <span>W {width || ''} | </span>
          <span>H {height || ''} | </span>
          <span>D {depth || ''}</span>
        </div>
        <div className="lm-feature__content-price">
          <LookFeaturePrice showPriceAlways={true} lookFeature={feature} className="lm-feature__content-price-text"/>
          {lookViewType === 4 ? <FeatureName feature={feature} useCollectionName={true}/> : null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  const { menuOpened } = store.sqftMenuState;
  const { visualizersLoaded, windowHeight, isMobile } = store.serverState;
  const { lookViewType } = store.lookState;

  return {
    menuOpened,
    windowHeight,
    isMobile,
    lookViewType,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

export default connect(mapStateToProps)(SqftOptionsRelatedItemRow);
